/**
 * /continue — on-page YouTube player, Inglewood coupon copy, and owner-page events.
 * Events: continue_video_play | continue_inglewood_view | continue_inglewood_coupon_copy | continue_inglewood_click
 *
 * Cards are links to youtube.com/watch so they still work without JS. With JS,
 * a tap opens the player dialog on this page and pushes ?video={id} so the
 * browser Back button returns to the library. The iframe is only created after
 * that tap (or a ?video= deep link) and is removed on close.
 */
(function () {
  var EMBED_ORIGIN = 'https://www.youtube-nocookie.com';
  var READY_TIMEOUT_MS = 12000;

  function publish(name, payload) {
    var data = payload || {};
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {
      /* customer pixels may not be listening */
    }
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: data }));
    } catch (e2) {
      /* ignore */
    }
  }

  function fallbackCopy(text, done) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'absolute';
    area.style.left = '-9999px';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
    } catch (e) {
      /* ignore */
    }
    document.body.removeChild(area);
    done();
  }

  function watchUrl(id) {
    return 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
  }

  function initPlayer(root) {
    var dialog = root.querySelector('[data-continue-player]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var frame = dialog.querySelector('[data-continue-frame]');
    var kicker = dialog.querySelector('[data-continue-player-kicker]');
    var titleEl = dialog.querySelector('[data-continue-player-title]');
    var creatorEl = dialog.querySelector('[data-continue-player-creator]');
    var youtubeLink = dialog.querySelector('[data-continue-player-youtube]');
    var errorBox = dialog.querySelector('[data-continue-player-error]');
    var errorLink = dialog.querySelector('[data-continue-player-error-link]');
    var prevBtn = dialog.querySelector('[data-continue-prev]');
    var nextBtn = dialog.querySelector('[data-continue-next]');
    var closeBtn = dialog.querySelector('[data-continue-close]');

    var links = Array.prototype.slice.call(root.querySelectorAll('[data-continue-video]'));
    if (!links.length) return;

    var current = null;
    var trigger = null;
    var pushedHistory = false;
    var readyTimer = null;
    var savedOverflow = '';

    function itemFor(link) {
      return {
        id: link.getAttribute('data-continue-video'),
        category: link.getAttribute('data-continue-category') || 'watch_discover',
        aspect: link.getAttribute('data-continue-aspect') === '9:16' ? '9:16' : '16:9',
        title: link.getAttribute('data-continue-title') || '',
        creator: link.getAttribute('data-continue-creator') || '',
        creatorUrl: link.getAttribute('data-continue-creator-url') || '',
        chords: link.getAttribute('data-continue-chords') === '1',
        link: link,
      };
    }

    var items = links.map(itemFor);

    function find(id) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === id) return items[i];
      }
      return null;
    }

    function siblings(item) {
      return items.filter(function (other) {
        return other.category === item.category;
      });
    }

    function urlWith(id) {
      var url = new URL(window.location.href);
      if (id) url.searchParams.set('video', id);
      else url.searchParams.delete('video');
      return url.pathname + url.search + url.hash;
    }

    function clearTimer() {
      if (readyTimer) {
        window.clearTimeout(readyTimer);
        readyTimer = null;
      }
    }

    function showError() {
      clearTimer();
      if (!current) return;
      errorLink.href = watchUrl(current.id);
      errorBox.hidden = false;
    }

    function mountIframe(item, autoplay) {
      clearTimer();
      frame.innerHTML = '';
      errorBox.hidden = true;

      var params = new URLSearchParams({
        playsinline: '1',
        rel: '0',
        modestbranding: '1',
        enablejsapi: '1',
        origin: window.location.origin,
      });
      if (autoplay) params.set('autoplay', '1');

      var iframe = document.createElement('iframe');
      iframe.src = EMBED_ORIGIN + '/embed/' + encodeURIComponent(item.id) + '?' + params.toString();
      iframe.title = item.title ? item.title + ' (YouTube video)' : 'YouTube video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.addEventListener('load', function () {
        try {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening', id: item.id, channel: 'widget' }), EMBED_ORIGIN);
        } catch (e) {
          /* ignore */
        }
      });
      frame.appendChild(iframe);

      // onload cannot prove the video plays; wait for the player's onReady.
      readyTimer = window.setTimeout(showError, READY_TIMEOUT_MS);
    }

    function render(item, autoplay) {
      current = item;
      dialog.setAttribute('data-aspect', item.aspect);
      frame.setAttribute('data-aspect', item.aspect);

      kicker.textContent = item.category === 'play_along'
        ? (item.chords ? 'Play Along · Chord charts on screen' : 'Play Along')
        : 'Watch & Discover';
      titleEl.textContent = item.title;

      creatorEl.textContent = '';
      if (item.creator) {
        if (item.creatorUrl) {
          var a = document.createElement('a');
          a.href = item.creatorUrl;
          a.target = '_blank';
          a.rel = 'noopener';
          a.textContent = item.creator;
          creatorEl.appendChild(a);
        } else {
          creatorEl.textContent = item.creator;
        }
      }
      youtubeLink.href = watchUrl(item.id);

      var list = siblings(item);
      var index = list.indexOf(item);
      var multiple = list.length > 1;
      prevBtn.hidden = !multiple;
      nextBtn.hidden = !multiple;
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= list.length - 1;

      mountIframe(item, autoplay);
      publish('continue_video_play', { id: item.id, category: item.category });
    }

    function lockScroll() {
      savedOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.documentElement.style.overflow = savedOverflow;
    }

    function open(item, opts) {
      var options = opts || {};
      trigger = item.link;
      render(item, options.autoplay !== false);
      if (!dialog.open) {
        lockScroll();
        dialog.showModal();
        closeBtn.focus();
      }
      if (options.push) {
        history.pushState({ continueVideo: item.id }, '', urlWith(item.id));
        pushedHistory = true;
      }
    }

    function teardown() {
      clearTimer();
      frame.innerHTML = '';
      current = null;
      if (dialog.open) dialog.close();
      unlockScroll();
      if (trigger) {
        trigger.focus({ preventScroll: true });
      }
    }

    function requestClose() {
      if (pushedHistory) {
        pushedHistory = false;
        history.back();
        return;
      }
      history.replaceState(history.state, '', urlWith(null));
      teardown();
    }

    function step(delta) {
      if (!current) return;
      var list = siblings(current);
      var next = list[list.indexOf(current) + delta];
      if (!next) return;
      trigger = next.link;
      render(next, true);
      history.replaceState({ continueVideo: next.id }, '', urlWith(next.id));
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        var item = find(link.getAttribute('data-continue-video'));
        if (!item) return;
        event.preventDefault();
        open(item, { push: true });
      });
    });

    closeBtn.addEventListener('click', requestClose);
    prevBtn.addEventListener('click', function () {
      step(-1);
    });
    nextBtn.addEventListener('click', function () {
      step(1);
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      requestClose();
    });

    window.addEventListener('popstate', function () {
      var id = new URL(window.location.href).searchParams.get('video');
      var item = id ? find(id) : null;
      if (item) {
        if (!current || current.id !== item.id) open(item, { autoplay: false });
        pushedHistory = true;
      } else if (dialog.open) {
        pushedHistory = false;
        teardown();
      }
    });

    window.addEventListener('message', function (event) {
      if (event.origin !== EMBED_ORIGIN && event.origin !== 'https://www.youtube.com') return;
      var data = event.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }
      if (!data || !current) return;
      if (data.event === 'onReady' || data.event === 'initialDelivery' || data.event === 'infoDelivery') {
        clearTimer();
      }
      if (data.event === 'onError') {
        showError();
      }
    });

    var deepLink = new URL(window.location.href).searchParams.get('video');
    if (deepLink) {
      var linked = find(deepLink);
      if (linked) {
        open(linked, { autoplay: false });
      } else {
        history.replaceState(history.state, '', urlWith(null));
      }
    }
  }

  function initBack(root) {
    var back = root.querySelector('[data-continue-back]');
    if (!back) return;
    back.addEventListener('click', function (event) {
      var fromCompanion = /^https:\/\/start\.jaromin\.com\//.test(document.referrer || '');
      if (fromCompanion && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
      }
    });
  }

  function initCourse(root) {
    var partner = root.querySelector('[data-continue-partner]');
    if (partner && 'IntersectionObserver' in window) {
      var seen = false;
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (seen || !entry.isIntersecting) return;
            seen = true;
            publish('continue_inglewood_view', { page: 'continue' });
            observer.disconnect();
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(partner);
    } else if (partner) {
      publish('continue_inglewood_view', { page: 'continue' });
    }

    var copyBtn = root.querySelector('[data-continue-copy]');
    var codeEl = root.querySelector('[data-continue-code]');
    var copied = root.querySelector('[data-continue-copied]');
    if (copyBtn && codeEl) {
      copyBtn.addEventListener('click', function () {
        var code = (codeEl.textContent || '').trim();
        function ok() {
          publish('continue_inglewood_coupon_copy', { code: code });
          copyBtn.textContent = 'Copied';
          if (copied) copied.textContent = 'Coupon code copied';
          window.setTimeout(function () {
            copyBtn.textContent = 'Copy code';
            if (copied) copied.textContent = '';
          }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(ok).catch(function () {
            fallbackCopy(code, ok);
          });
        } else {
          fallbackCopy(code, ok);
        }
      });
    }

    root.querySelectorAll('[data-continue-course]').forEach(function (link) {
      link.addEventListener('click', function () {
        publish('continue_inglewood_click', { href: link.getAttribute('href') || '' });
      });
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-continue-ready') === '1') return;
    root.setAttribute('data-continue-ready', '1');
    initBack(root);
    initPlayer(root);
    initCourse(root);
  }

  function boot() {
    document.querySelectorAll('[data-continue-page]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
